import alasql from "alasql";
const HALF_HOUR = 0, HOUR = 1, SHIFT = 2, DAY = 3, WEEK = 4, MONTH = 5, YEAR = 6;
const week_names = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
const month_names = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
let zoom1 = null;
let nome_prima_col_tot = "";
let spostamento = true;

const normalize = [
    null,
    function (date) { date.setMinutes(0); },
    function (date) { date.setMinutes(0); },
    function (date) { date.setHours(0); },
    function (date) { date.setHours(0); },
    function (date) { date.setDate(1); },
    function (date) { date.setMonth(0); },
]

const reference = new Date();
let dragged = null;

let data_inizio = new Date();

// Funzione per aggiornare il task dopo il drop nell'indexedDB
async function updateDB(ris, id_task, id_target, durata, riga, partenza) {

    id_target = id_target * 1 - 1;
    console.log("Id_task" + id_task);
    console.log(id_target);
    let task_list = [];
    console.log(partenza);
    await new Promise((resolve) => {
        alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
        SELECT * FROM commessa_db.task WHERE id_task = ${id_task}`, [], function (res) {
            task_list.push(res[1][0]);
            resolve();
        });
    });

    console.log(nome_prima_col_tot);
    // console.log("Task spostato: ", task_list);
    // console.log(task_list[0].data_inizio);
    let data_inizio_prec = new Date(task_list[0].data_inizio);
    console.log("Durata", durata);
    let data_fine_prec = new Date(task_list[0].data_fine);
    console.log("Data fine prec:", data_fine_prec);

    let data_temp = new Date();
    data_temp.setTime(data_inizio);
    let data_nuova = data_temp;
    //console.log("data nuova inizio " + data_nuova);
    let data_nuova_fine = new Date();
    let valore_nuovo = null;
    let valore_nuovo_ore = null;
    let valore_nuovo_minuti = null;
    let valore_nuovo_giorno = null;
    let giorno_fine = null;

    switch (zoom1) {
        case HALF_HOUR: // Da sistemare
            valore_nuovo_minuti = data_inizio.getMinutes() * 1 + (id_target) * 30;
            data_nuova.setMinutes(valore_nuovo_minuti);
            valore_nuovo_ore = data_nuova.getHours() * 1;
            valore_nuovo_giorno = data_nuova.getDate() * 1 + Math.floor(durata / 24);
            data_nuova_fine.setMinutes(valore_nuovo_minuti + Math.floor(durata * 30));
            data_nuova_fine.setHours(valore_nuovo_ore + Math.floor(durata / 2));
            data_nuova_fine.setDate(valore_nuovo_giorno);
            data_nuova_fine.setMonth(data_fine_prec.getMonth());
            data_nuova_fine.setSeconds('00');
            console.log("data nuova inizio " + data_nuova);
            console.log("data nuova fine " + data_nuova_fine);
            break;
        case HOUR:
            valore_nuovo_ore = data_inizio.getHours() * 1 + id_target * 1 + 1;
            console.log("Id_target: ", id_target);
            data_nuova.setHours(valore_nuovo_ore);
            data_nuova.setMinutes(data_inizio_prec.getMinutes());
            valore_nuovo_giorno = data_nuova.getDate() * 1 + (durata / 24);
            // Probabile problema nella riga dopo riguardo l'approssimazione
            data_nuova_fine.setHours(valore_nuovo_ore + Math.floor(durata * 1) + 1);
            console.log("valore nuovo ore: ", valore_nuovo_ore + Math.floor(durata * 1) + 1);
            data_nuova_fine.setDate(valore_nuovo_giorno);
            data_nuova_fine.setMinutes(data_fine_prec.getMinutes());
            data_nuova_fine.setSeconds('00');
            if (data_nuova_fine.getDate() > 31) { data_nuova_fine.setMonth(data_nuova.getMonth() * 1 + 1); }
            else { data_nuova_fine.setMonth(data_nuova.getMonth()); }
            break;
        case SHIFT:
            valore_nuovo_ore = data_inizio.getHours() * 1 + (id_target + 1) * 8;
            console.log("valore nuovo ore: ", valore_nuovo_ore);
            data_nuova.setHours(valore_nuovo_ore);
            valore_nuovo_giorno = data_nuova.getDate() * 1 + ((durata) / 3);
            console.log("data nuova inizio" + data_nuova);
            data_nuova_fine.setHours(valore_nuovo_ore + (durata) * 8);
            console.log("valore nuovo ore fine: ", valore_nuovo_ore + (durata) * 8);
            data_nuova_fine.setDate(valore_nuovo_giorno);
            data_nuova_fine.setMonth(data_nuova.getMonth());
            data_nuova_fine.setMinutes(data_fine_prec.getMinutes());
            data_nuova_fine.setSeconds('00');
            break;
        case DAY:
            valore_nuovo = data_inizio.getDate() * 1 + id_target * 1;
            data_nuova.setDate(valore_nuovo);
            data_nuova.setHours(data_inizio_prec.getHours());
            data_nuova.setMinutes(data_inizio_prec.getMinutes());
            // console.log("Data nuova: ", data_nuova);
            giorno_fine = (data_nuova.getDate() * 1 + durata * 1);
            data_nuova_fine.setHours(data_fine_prec.getHours());
            data_nuova_fine.setMonth(data_nuova.getMonth());
            data_nuova_fine.setDate(giorno_fine);
            data_nuova_fine.setMinutes(data_fine_prec.getMinutes());
            data_nuova_fine.setSeconds('00');
            if (data_nuova_fine.getDate() < durata) { data_nuova_fine.setMonth(data_nuova.getMonth() + 1); }
            else if (valore_nuovo > 31) { data_nuova_fine.setMonth(data_nuova.getMonth()); }
            else { data_nuova_fine.setMonth(data_nuova.getMonth()); }
            break;
        case WEEK: //Da sistemare
            data_nuova.setDate(data_inizio.getDate() + id_target);
            while (data_inizio.getDay() != 1) { data_inizio.setDate(data_inizio.getDate() + id_target); } //Inizio settimana al lunedì
            data_nuova_fine.setDate(data_nuova.getDate() + durata);
            while (data_nuova.getDay() != 1) { data_nuova_fine.setDate(data_nuova_fine.getDate() - 1); }
            break;
        case MONTH: //Da sistemare
            data_nuova.setMonth(data_inizio.getMonth() + id_target);
            data_nuova_fine.setMonth(data_nuova.getMonth() + durata);
            break;
        case YEAR: //Da sistemare
            data_nuova.setFullYear(data_inizio.getFullYear() + id_target);
            data_nuova_fine.setFullYear(data_nuova.getFullYear() + durata);
            break;

    }
    //Format delle date per caricarle sull'indexedDB
    var datestring1 = `${data_nuova.getFullYear()}-${(data_nuova.getMonth() + 1).toString().padStart(2, "0")}-${data_nuova.getDate().toString().padStart(2, "0")}T${data_nuova.getHours().toString().padStart(2, "0")}:${data_nuova.getMinutes().toString().padStart(2, "0")}:${data_nuova.getSeconds().toString().padStart(2, "0")}`;
    var datestring2 = `${data_nuova_fine.getFullYear()}-${(data_nuova_fine.getMonth() + 1).toString().padStart(2, "0")}-${data_nuova_fine.getDate().toString().padStart(2, "0")}T${data_nuova_fine.getHours().toString().padStart(2, "0")}:${data_nuova_fine.getMinutes().toString().padStart(2, "0")}:${data_nuova_fine.getSeconds().toString().padStart(2, "0")}`;

    console.log("data fine dopo " + data_nuova_fine);

    if (nome_prima_col_tot == "attivita") {
        alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.task SET id_attivita = ${ris}, data_inizio = "${datestring1}", data_fine = "${datestring2}", modificato = 1 WHERE id_task = ${id_task}`, [], function () {
        });
    }

    if (nome_prima_col_tot == "operatori") {

        if (task_list[0].operatori.length == 1) {
            let oper = new Array();
            oper[0] = ris;
            console.log(oper);
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.task SET operatori = ?, data_inizio = "${datestring1}", data_fine = "${datestring2}", modificato = 1 WHERE id_task = ${id_task}`, [oper], function () {
            });
        }

        else { //Trovare operatore liberato all'interno degli operatori e scambiare con il nuovo, id personale ce ne sono due e devo prendere quello giusto

            let oper = new Array();
            for (let i = 0; i < task_list[0].operatori.length; i++) {
                oper[i] = task_list[0].operatori[i];
            }

            for (let k = 0; k < oper.length; k++) {
                if (oper[k] == partenza) {
                    oper[k] = ris;
                }
            }

            console.log(oper);
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            UPDATE commessa_db.task SET operatori = ?, modificato = 1 WHERE id_task = ${id_task}`, [oper], function () {
            });
        }
    }
}
// Funzione per gestire il drop di un task dopo il drag
async function ondrop(e) {

    //Controllo che la cella di arrivo sia valida
    spostamento = true;
    let cursorX = '';
    let cursorY = '';
    cursorX = e.pageX;
    cursorY = e.pageY;
    let lunghezza = dragged.getAttribute('lunghezza');
    let elements = document.elementsFromPoint(cursorX, cursorY);
    let elements_prim_meta = document.elementsFromPoint(cursorX * 1 + 20 * lunghezza, cursorY);
    let elements_meta = document.elementsFromPoint(cursorX * 1 + 30 * lunghezza, cursorY);
    let elements_sec_meta = document.elementsFromPoint(cursorX * 1 + 40 * lunghezza, cursorY);
    let elements_fine = document.elementsFromPoint(cursorX * 1 + 60 * lunghezza, cursorY);
    let result = 2;

    let operatori_compe = new Array();
    await new Promise((resolve) => {
        alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
    SELECT operatori_con_competenze FROM commessa_db.task WHERE id_task = ${dragged.getAttribute("id_task")}`, [], function (res) {
            if (res[1][0].operatori_con_competenze != null) {
                for (let j = 0; j < res[1][0].operatori_con_competenze.length; j++) {
                    operatori_compe[j] = res[1][0].operatori_con_competenze[j];
                }
            }
            resolve();
        });
    });

    let codice_opera = parseInt(e.target.getAttribute(nome_prima_col_tot));
    let span_target1 = null;
    if (e.target.tagName.toLowerCase() === 'b' || e.target.tagName.toLowerCase() === 'i') {
        span_target1 = e.target.parentNode;
        let div_target = span_target1.parentNode;
        let fig_target = div_target.parentNode;
        let td_target = fig_target.parentNode;
        codice_opera = parseInt(td_target.getAttribute(nome_prima_col_tot));
    } else if (e.target.tagName.toLowerCase() === 'span') {
        span_target1 = e.target;
        let div_target = span_target1.parentNode;
        let fig_target = div_target.parentNode;
        let td_target = fig_target.parentNode;
        codice_opera = parseInt(td_target.getAttribute(nome_prima_col_tot));
    }

    let operatore_presente = false;
    if (operatori_compe.length == 0 || operatori_compe == null) {
        operatore_presente = true;
    }
    else {
        for (let i = 0; i < operatori_compe.length; i++) {
            if (codice_opera == operatori_compe[i]) {
                operatore_presente = true;
            }
        }
    }

    console.log("Operatori per task: ", operatori_compe);
    // console.log("elementi ");
    // console.log(elements);
    for (let i = 0; i < elements.length; i++) { // Ciclo tutti i tag individuati nel punto di drop per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements[i]);
        if (elemento.getAttribute('data-itemtype') || e.target.tagName.toLowerCase() === 'span') {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;

            } else if (e.target.tagName.toLowerCase() !== 'td' && elemento.getAttribute('id_task') == dragged.getAttribute('id_task')) {
                result = 3;
            }
        }
    }

    for (let i = 0; i < elements_prim_meta.length; i++) { // Ciclo tutti i tag individuati prima della metà per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements_prim_meta[i]);
        if (elemento.getAttribute('data-itemtype')) {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }

    for (let i = 0; i < elements_meta.length; i++) { // Ciclo tutti i tag individuati nel punto a metà per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements_meta[i]);
        if (elemento.getAttribute('data-itemtype')) {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }

    for (let i = 0; i < elements_sec_meta.length; i++) { // Ciclo tutti i tag individuati poco dopo la metà per vedere se c'è il td con l'attributo che ci interessa
        const elemento = (elements_sec_meta[i]);
        if (elemento.getAttribute('data-itemtype')) {

            // Controllo anche che il task target non sia lo stesso di partenza per evitare di fare una riga se non necessario
            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }

    for (let i = 0; i < elements_fine.length; i++) { // Come sopra ma controllo che non ci sia nulla nella cella finale del td dragged
        const elemento = (elements_fine[i]);
        if (elemento.getAttribute('data-itemtype')) {

            if (e.target.tagName.toLowerCase() === 'td' && elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 0;
            }
            else if (elemento.getAttribute('id_task') !== dragged.getAttribute('id_task')) {
                result = 1;
            }
        }
    }

    console.log("Result: ", result);
    // console.log("result" + result);
    // Cella target vuota
    if (result == 2) {

        e.preventDefault();

        let nome_prima_col_tot_2 = parseInt(e.target.getAttribute(nome_prima_col_tot));
        console.log(nome_prima_col_tot_2);

        if (nome_prima_col_tot != "operatori" || operatore_presente) {
            let row_dragged = dragged.parentNode;

            const cella_sostitutiva = document.createElement('td');
            cella_sostitutiva.id = dragged.id;

            console.log("nome prima colonna", nome_prima_col_tot);
            cella_sostitutiva.setAttribute(nome_prima_col_tot, dragged.getAttribute(nome_prima_col_tot));
            cella_sostitutiva.addEventListener('drop', function (e) {
                ondrop(e);
                e.preventDefault()
            });
            cella_sostitutiva.addEventListener('dragover', function (e) {
                e.preventDefault()
            }, false);
            cella_sostitutiva.addEventListener('dragleave', function (e) {
                e.preventDefault()
            }, false);

            let partenza = dragged.getAttribute(nome_prima_col_tot);
            // Modifico i campi del task
            //let row_id = e.target.parentNode.id;
            let id_task = dragged.getAttribute("id_task");

            dragged.setAttribute(nome_prima_col_tot, nome_prima_col_tot_2);
            let riga = e.target.parentNode.getAttribute("riga");
            // console.log("id_task prima di spostamento" + id_task);
            // console.log("ris prima di spost" + attivita);
            let durata = dragged.getAttribute("durata");

            let id = "";

            if (nome_prima_col_tot == "operatori" && dragged.getAttribute("num_operatori") > 1) {
                id = dragged.id;
                if (e.target.id != dragged.id) {
                    spostamento = "quasi";
                }
            } else if (nome_prima_col_tot != "operatori" || dragged.getAttribute("num_operatori") == 1) {
                id = e.target.id;
            }

            // Ciclo per individuale elemento del database da cambiare
            updateDB(nome_prima_col_tot_2, id_task, id, durata, riga, partenza);

            if (nome_prima_col_tot != "operatori" || dragged.getAttribute("num_operatori") == 1) {
                dragged.id = id;
            }

            e.preventDefault();
            dragged.parentNode.replaceChild(cella_sostitutiva, dragged);

            if (nome_prima_col_tot != "operatori" || dragged.getAttribute("num_operatori") == 1) {
                e.target.parentNode.replaceChild(dragged, e.target);
            } else {
                console.log(dragged.id);
                let new_target = document.getElementById(e.target.parentNode.id).getElementsByTagName('td')[dragged.id];
                console.log(new_target);
                e.target.parentNode.replaceChild(dragged, new_target);
            }

            // Rimuovo la riga se è rimasta vuota
            let rimasto = row_dragged.querySelectorAll("[data-itemtype = '0']");
            let rimasto_vinc = row_dragged.querySelectorAll("[data-itemtype = '2']");
            let rimasto_risorsa = row_dragged.querySelectorAll("[data-itemtype = '1']");
            if (rimasto[0] == undefined && rimasto_vinc[0] == undefined && rimasto_risorsa[0] == undefined) {
                row_dragged.remove();
            }
        } else { spostamento = false; }
    } else if (result == 0) {  // Cella target occupata con span

        console.log(operatore_presente);
        if (nome_prima_col_tot != "operatori" || operatore_presente) {
            let row_dragged = dragged.parentNode;
            let row_target = e.target.parentNode;
            let id = "";

            if (nome_prima_col_tot == "operatori" && dragged.getAttribute("num_operatori") > 1) {
                id = dragged.id;
                if (e.target.id != dragged.id) {
                    spostamento = "quasi";
                }
            } else if (nome_prima_col_tot != "operatori" || dragged.getAttribute("num_operatori") == 1) {
                id = e.target.id;
            }

            const cella_sostitutiva = document.createElement('td');
            cella_sostitutiva.id = dragged.id;
            cella_sostitutiva.setAttribute(nome_prima_col_tot, dragged.getAttribute(nome_prima_col_tot));
            cella_sostitutiva.addEventListener('drop', function (e) {
                ondrop(e);
                e.preventDefault()
            });
            cella_sostitutiva.addEventListener('dragover', function (e) {
                e.preventDefault()
            }, false);
            cella_sostitutiva.addEventListener('dragleave', function (e) {
                e.preventDefault()
            }, false);

            if (nome_prima_col_tot != "operatori" || dragged.getAttribute("num_operatori") == 1) {
                dragged.id = id;
            }

            let partenza = dragged.getAttribute(nome_prima_col_tot);
            let nome_prima_col_tot_2 = parseInt(e.target.getAttribute(nome_prima_col_tot));
            dragged.setAttribute(nome_prima_col_tot, nome_prima_col_tot_2);
            const new_row = document.createElement('tr');
            new_row.setAttribute('elemento', "attivita_row");
            const risorsa_cell = document.createElement('td');
            risorsa_cell.innerHTML = "ciao";
            risorsa_cell.style.height = "100%";
            new_row.appendChild(risorsa_cell);

            //Da sistemare numero td nuove righe
            for (let i = 1; i <= 100; i++) {
                const startcell = document.createElement('td');
                startcell.id = i;
                startcell.setAttribute(nome_prima_col_tot, e.target.getAttribute(nome_prima_col_tot));
                startcell.addEventListener('dragover', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('dragleave', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('drop', ondrop);
                new_row.appendChild(startcell);
            }

            // Modifico i campi del task
            let riga = e.target.parentNode.getAttribute("riga");
            let id_task = dragged.getAttribute("id_task");
            // console.log("id_task prima di spostamento" + id_task);
            let durata = dragged.getAttribute("durata");
            // Ciclo per individuale elemento del database da cambiare
            updateDB(nome_prima_col_tot_2, id_task, id, durata, riga * 1 + 1, partenza);

            new_row.id = nome_prima_col_tot + nome_prima_col_tot_2 + "-" + (riga * 1 + 1);

            row_target.parentNode.insertBefore(new_row, row_target.nextSibling);
            const new_target = document.getElementById(new_row.id).getElementsByTagName('td')[dragged.id];
            dragged.parentNode.replaceChild(cella_sostitutiva, dragged);
            new_target.parentNode.replaceChild(dragged, new_target);

            // Rimuovo la riga se è rimasta vuota
            let rimasto = row_dragged.querySelectorAll("[data-itemtype = '0']");
            let rimasto_vinc = row_dragged.querySelectorAll("[data-itemtype = '2']");
            let rimasto_risorsa = row_dragged.querySelectorAll("[data-itemtype = '1']");

            if (rimasto[0] == undefined && rimasto_vinc[0] == undefined && rimasto_risorsa[0] == undefined) {
                row_dragged.remove();
            }
        } else { spostamento = false; }

    } else if (result == 1) { // Cella target occupata ma sempre td
        // span è target
        console.log(operatore_presente);
        if (nome_prima_col_tot != "operatori" || operatore_presente) {
            let span_target = null;
            console.log("entrato");
            if (e.target.tagName.toLowerCase() === 'b' || e.target.tagName.toLowerCase() === 'i') {
                span_target = e.target.parentNode;
            } else {
                span_target = e.target;
            }

            let row_dragged = dragged.parentNode;
            let div_target = span_target.parentNode;
            let fig_target = div_target.parentNode;
            let td_target = fig_target.parentNode;
            let row_target = td_target.parentNode;
            let id = "";

            if (nome_prima_col_tot == "operatori" && dragged.getAttribute("num_operatori") > 1) {
                id = dragged.id;
                if (e.td_target.id != dragged.id) {
                    spostamento = "quasi";
                }
            } else if (nome_prima_col_tot != "operatori" || dragged.getAttribute("num_operatori") == 1) {
                id = td_target.id;
            }

            console.log("id destinazione", id);
            const cella_sostitutiva = document.createElement('td');
            cella_sostitutiva.id = dragged.id;
            cella_sostitutiva.setAttribute(nome_prima_col_tot, dragged.getAttribute(nome_prima_col_tot));
            cella_sostitutiva.addEventListener('drop', function (e) {
                ondrop(e);
                e.preventDefault()
            });
            cella_sostitutiva.addEventListener('dragover', function (e) {
                e.preventDefault()
            }, false);
            cella_sostitutiva.addEventListener('dragleave', function (e) {
                e.preventDefault()
            }, false);


            if (nome_prima_col_tot != "operatori" || dragged.getAttribute("num_operatori") == 1) {
                dragged.id = id;
            }

            dragged.setAttribute(nome_prima_col_tot, nome_prima_col_tot);

            const new_row = document.createElement('tr');
            new_row.setAttribute('elemento', "attivita_row");
            const risorsa_cell = document.createElement('td');
            risorsa_cell.innerHTML = "ciao";
            risorsa_cell.style.height = "100%";
            new_row.appendChild(risorsa_cell);

            //Da sistemare numero td nuove righe
            for (let i = 1; i <= 50; i++) {
                const startcell = document.createElement('td');
                startcell.id = i;
                startcell.setAttribute(nome_prima_col_tot, td_target.getAttribute(nome_prima_col_tot));
                startcell.addEventListener('dragover', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('dragleave', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('drop', ondrop);
                new_row.appendChild(startcell);
            }

            let partenza = dragged.getAttribute(nome_prima_col_tot);
            let nome_prima_col_tot_2 = parseInt(td_target.getAttribute(nome_prima_col_tot));
            let id_task = dragged.getAttribute("id_task");
            let riga = e.target.parentNode.getAttribute("riga");
            // console.log("id_task prima di spostamento" + id_task);
            let durata = dragged.getAttribute("durata");
            console.log("macchina arrivo: ", nome_prima_col_tot_2);
            updateDB(nome_prima_col_tot_2, id_task, id, durata, riga * 1 + 1, partenza);

            new_row.id = nome_prima_col_tot + nome_prima_col_tot_2 + "-" + (riga * 1 + 1);

            row_target.parentNode.insertBefore(new_row, row_target.nextSibling);
            const new_target = document.getElementById(new_row.id).getElementsByTagName('td')[dragged.id];
            dragged.parentNode.replaceChild(cella_sostitutiva, dragged);
            new_target.parentNode.replaceChild(dragged, new_target);

            // Rimuovo la riga se è rimasta vuota
            let rimasto = row_dragged.querySelectorAll("[data-itemtype = '0']");
            let rimasto_vinc = row_dragged.querySelectorAll("[data-itemtype = '2']");
            let rimasto_risorsa = row_dragged.querySelectorAll("[data-itemtype = '1']");
            if (rimasto[0] == undefined && rimasto_vinc[0] == undefined && rimasto_risorsa[0] == undefined) {
                row_dragged.remove();
            }
        } else { spostamento = false; }
    }


    if (nome_prima_col_tot == "operatori") {
        //Individuo le competenze richieste dal task spostato
        let competenze_task = [];
        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.task WHERE id_task = ${dragged.getAttribute("id_task")}`, [], function (res) {

                competenze_task = res[1][0].competenze_richieste;
                if (competenze_task != null) {
                    for (let i = 0; i < competenze_task.length; i++) {
                        competenze_task[i] = competenze_task[i].des_competenza;
                    }
                }
                resolve();
            });
        });

        let oper_cognome = "";
        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.operatori WHERE id_personale = ${codice_opera}`, [], function (res) {
                oper_cognome = res[1][0].cognome;

                resolve();
            });
        });
        let competenze_string = '';
        if (competenze_task != null) {
            competenze_string = competenze_task.join(', ');
        }
        const messaggio = { detail: { spostamento: spostamento, competenze: competenze_string, cognome: oper_cognome }, src: null };
        const evento = new CustomEvent("semaforo_spostamento", messaggio);
        document.getElementById("diagram_table").dispatchEvent(evento);
    }
}

class Calendar {
    zoom_levels = ['Mezz\'ore', 'Ore', 'Turni', 'Giorni', 'Settimane', 'Mesi', 'Anni'];
    blocks = new Array();
    zoom = DAY;
    task_modificati = new Array();
    db_connection = null;
    version_db = 5;

    constructor() { this.setStep(); }

    //-------------------------Creazione e aggiornamento IndexedDB
    gestore_db(attivita, tasks, operatori, info) {
        const that = this;
        // console.log("attivita");
        // console.log(attivita);
        if (attivita != undefined && tasks != undefined && operatori != undefined) {
            const dbName = "commessa_db";
            const obStoreAtt = "attivita";
            const obStoreTask = "task";
            const obStoreOp = "operatori";
            const obStoreIn = "info";

            var request = indexedDB.open(dbName, this.version_db);
            request.onerror = function (event) {
                console.log("errore apertura DB" + event);
            }

            request.onsuccess = function (res) {
                that.db_connection = res.target.result;
                // console.log("db_connection: ", that.db_connection);
            }
            request.onupgradeneeded = function (event) {
                var db = event.target.result;
                let objectStoreAtt = db.createObjectStore(obStoreAtt, { keyPath: "id_attivita" });
                let objectStoreTask = db.createObjectStore(obStoreTask, { keyPath: "id_task" });
                let objectStoreOp = db.createObjectStore(obStoreOp, { keyPath: "id_personale" });
                let objectStoreInfo = db.createObjectStore(obStoreIn, { keyPath: "id_info" });

                objectStoreAtt.transaction.oncomplete = function () {
                };
                objectStoreTask.transaction.oncomplete = function () {
                };
                objectStoreInfo.transaction.oncomplete = function () {
                };
                objectStoreOp.transaction.oncomplete = function () {

                    // Aggiungo i valori all'objectStore.
                    var attivitaObjectStore = db.transaction(obStoreAtt, "readwrite").objectStore(obStoreAtt);
                    var tasksObjectStore = db.transaction(obStoreTask, "readwrite").objectStore(obStoreTask);
                    var opObjectStore = db.transaction(obStoreOp, "readwrite").objectStore(obStoreOp);
                    var infoObjectStore = db.transaction(obStoreIn, "readwrite").objectStore(obStoreIn);

                    for (let k = 0; k < attivita.length; k++) {
                        let attivita1 = attivita[k];
                        attivitaObjectStore.add(attivita1);
                    }

                    for (let j = 0; j < tasks.length; j++) {
                        let task = tasks[j];
                        tasksObjectStore.add(task);
                    }

                    for (let i = 0; i < operatori.length; i++) {
                        let operatore1 = operatori[i];
                        opObjectStore.put(operatore1);
                    }

                    for (let i = 0; i < info.length; i++) {
                        let info1 = info[i];
                        infoObjectStore.put(info1);
                    }
                };
            };
        }
    }

    // Azzeramento minuti, secondi ecc
    normalizeCalendar(date) {

        date.setSeconds(0);
        date.setMilliseconds(0);

        try {
            for (let j = this.zoom; j >= 0; j--) {
                const norm_func = normalize[j];
                if (norm_func == null) { continue; }
                norm_func(date);
            }
        } catch (error) {
            window.error = error;
        }
    }

    //-------------------------Costruzione del calendario e inserimento task
    async build(prima_col, tasks, nome_key, nome_prima_col, data_inizio_filt, data_fine_filt, info) {

        console.log(prima_col, nome_key, nome_prima_col);
        nome_prima_col_tot = nome_prima_col;
        let task_length = tasks.length;
        console.log(nome_prima_col_tot);
        let oper_list = new Array();

        for (let j = 0; j < task_length; j++) {
            tasks[j].riga = 0;

        }

        // Carico i dati dall'IndexedDb se sono presenti


        if (nome_prima_col == "operatori") {
            await new Promise((resolve) => {
                alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
                SELECT * FROM commessa_db.${nome_prima_col} ORDER BY cognome`, [], function (res) {
                    for (let i = 0; i < res[1].length; i++) {
                        prima_col[i] = res[1][i];
                    }
                    resolve();
                });
            });
        } else {
            await new Promise((resolve) => {
                alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
                SELECT * FROM commessa_db.${nome_prima_col}`, [], function (res) {
                    for (let i = 0; i < res[1].length; i++) {
                        prima_col[i] = res[1][i];
                    }
                    resolve();
                });
            });
        }

        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.operatori`, [], function (res) {
                for (let i = 0; i < res[1].length; i++) {
                    oper_list[i] = res[1][i];
                }
                resolve();
            });
        });

        // Cerco data inizio e fine tra le date delle attività

        let start_date = null;
        let end_date = null;

        if (data_inizio_filt == null || data_fine_filt == null) {

            let date_list_inizio = new Array();
            let date_list_fine = new Array();

            if (data_inizio_filt == null) {

                await new Promise((resolve) => {
                    alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.attivita ORDER BY dataInizio`, [], function (res) {
                        for (let i = 0; i < res[1].length; i++) {
                            let dataInizio = new Date();
                            dataInizio = res[1][i].dataInizio;
                            date_list_inizio.push(dataInizio);

                        }
                        resolve();
                    });
                });
                start_date = new Date(date_list_inizio[0]);
                start_date.setDate(start_date.getDate() * 1 - 2);
                //console.log(start_date);
                //console.log(date_list_inizio[0]);
            } else {
                start_date = new Date(data_inizio_filt);
                console.log("Zoom ", this.zoom);
            }

            if (data_fine_filt == null) {
                await new Promise((resolve) => {
                    alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.attivita ORDER BY dataFine`, [], function (res) {
                        for (let i = 0; i < res[1].length; i++) {

                            let dataFine = new Date();
                            dataFine = res[1][i].dataFine;
                            date_list_fine.push(dataFine);

                        }
                        resolve();
                    });
                });
                end_date = new Date(date_list_fine[date_list_fine.length * 1 - 1]);
                end_date.setDate(end_date.getDate() * 1 + 2);

            } else {
                end_date = new Date(data_fine_filt);
            }
        } else {
            start_date = new Date(data_inizio_filt);
            console.log("Zoom ", this.zoom);
            end_date = new Date(data_fine_filt);
        }

        //start_date.setHours("00");
        start_date.setMilliseconds(0);
        //end_date.setHours("00");

        if (this.zoom == 1) {
            start_date.setHours(start_date.getHours() * 1 - 1);
        }

        //start_date.setHours(6);
        console.log(start_date);
        console.log(end_date);


        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
        UPDATE commessa_db.task SET riga = 0`, [], function () {
                resolve();
            });
        });

        var data_iniz_DB = `${start_date.getFullYear()}-${(start_date.getMonth() + 1).toString().padStart(2, "0")}-${start_date.getDate().toString().padStart(2, "0")}T${start_date.getHours().toString().padStart(2, "0")}:${start_date.getMinutes().toString().padStart(2, "0")}:${start_date.getSeconds().toString().padStart(2, "0")}`;
        var data_fine_DB = `${end_date.getFullYear()}-${(end_date.getMonth() + 1).toString().padStart(2, "0")}-${end_date.getDate().toString().padStart(2, "0")}T${end_date.getHours().toString().padStart(2, "0")}:${end_date.getMinutes().toString().padStart(2, "0")}:${end_date.getSeconds().toString().padStart(2, "0")}`;
        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.task WHERE data_inizio>="${data_iniz_DB}" AND data_fine<="${data_fine_DB}"`, [], function (res) {
                tasks = new Array();
                for (let i = 0; i < res[1].length; i++) {
                    tasks[i] = res[1][i];
                    //console.log(res[1][i].data_inizio);
                }
                resolve();
            });
        });

        let data_inizio_info = `${start_date.getFullYear()}-${(start_date.getMonth() + 1).toString().padStart(2, "0")}-${start_date.getDate().toString().padStart(2, "0")}T00:00:00`;
        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
            SELECT * FROM commessa_db.info WHERE giorno>="${data_inizio_info}" AND giorno<="${data_fine_DB}"`, [], function (res) {
                info = new Array();
                for (let i = 0; i < res[1].length; i++) {
                    info[i] = res[1][i];
                    //console.log(res[1][i].data_inizio);
                }
                resolve();
            });
        });
        //console.log("Data inizio info:", data_inizio_info);
        //console.log("INFO DA DB:", info);

        if (this.zoom == 2) {
            start_date.setDate(start_date.getDate() * 1 - 1);
            //console.log("Entrato data");
        }

        if (this.zoom == 4) {
            let day_of_week = start_date.getDay() - 1;
            start_date.setDate(start_date.getDate() - day_of_week);
            console.log("Data iniziale:", start_date);
        }

        let data_temp = new Date();
        data_temp.setTime(start_date);
        data_inizio = data_temp;

        //---------------------- CREAZIONE CALENDARIO
        reference.setTime(start_date.getTime());
        this.normalizeCalendar(reference);
        switch (this.zoom) {
            case HALF_HOUR:
                reference.setMinutes(reference.getMinutes());
                break;
            case HOUR:
                reference.setHours(reference.getHours() + 1);
                break;
            case SHIFT:
                reference.setHours(reference.getHours() + 6);
                break;
            case DAY:
                reference.setDate(reference.getDate());
                break;
            case WEEK:
                reference.setDate(reference.getDate());
                while (reference.getDay() != 1) { reference.setDate(reference.getDate() - 1); } //Inizio settimana al lunedì
                break;
            case MONTH:
                reference.setMonth(reference.getMonth());
                break;
            case YEAR:
                reference.setFullYear(reference.getFullYear());
                break;
        }

        const stepDate = this.getFormatter(reference);
        const fragments = { upper: new DocumentFragment(), lower: new DocumentFragment() };
        const last_upperblock = { reference: null, colspan: 1, value: null };
        this.blocks = new Array();
        const target = new Date(end_date.getTime());
        //target.step(2);

        do {
            this.blocks.push(reference.getTime());
            const values = stepDate();
            const block = document.createElement('th');
            block.setAttribute("class", "head_fix_sotto");
            if (this.zoom == 2) {
                block.style.setProperty('--larghezza_td', 110);
            } else if (this.zoom == 3) {
                block.style.setProperty('--larghezza_td', 250);
            } else if (this.zoom == 4) {
                block.style.setProperty('--larghezza_td', 400);
            } else {
                block.style.setProperty('--larghezza_td', 60);
            }
            block.innerText = values.lower;
            fragments.lower.appendChild(block);

            if (values.upper != last_upperblock.value) {
                last_upperblock.value = values.upper;
                last_upperblock.colspan = 1;
                last_upperblock.reference = document.createElement('th');
                last_upperblock.reference.setAttribute("class", "head_fix");
                last_upperblock.reference.innerText = values.upper;
                fragments.upper.appendChild(last_upperblock.reference);
            } else {
                last_upperblock.colspan++;
                last_upperblock.reference.setAttribute('colspan', last_upperblock.colspan);
            }
        } while (reference <= target);

        requestAnimationFrame(function () {
            const header = document.getElementById('diagram_table').getElementsByTagName('thead')[0];
            const headers = {
                upper: header.children[0],
                lower: header.children[1]
            };
            var prima_col = document.createElement('th');
            prima_col.innerHTML = 'Attività';

            if (nome_prima_col == "attivita") {
                prima_col.innerHTML = 'Attività';
            }

            if (nome_prima_col == "operatori") {
                prima_col.innerHTML = 'Operatori';
            }

            headers.upper.innerHTML = '';
            headers.lower.innerHTML = '';


            prima_col.setAttribute("class", "col_titolo");
            var prima_col_su = document.createElement('th');


            headers.upper.appendChild(prima_col_su);
            headers.upper.appendChild(fragments.upper);
            headers.lower.appendChild(prima_col);
            headers.lower.appendChild(fragments.lower);

        });

        const body = document.getElementById('diagram_table').getElementsByTagName('tbody')[0];
        body.innerHTML = '';
        let prima_col_length = prima_col.length;
        // Creo riga per il totale operatori
        if ((this.zoom == 2 || this.zoom == 3 || this.zoom == 4) && nome_prima_col == "operatori") {
            const total_row_diagram = document.createElement('tr');
            total_row_diagram.setAttribute('elemento', "totale_op");
            total_row_diagram.id = "calcolo-operatori";
            const risorsa_cell = document.createElement('td');
            risorsa_cell.innerHTML = "Operatori impegnati";
            risorsa_cell.setAttribute('data-itemtype', 1);
            risorsa_cell.setAttribute("class", "col_attivita titolo-oper");
            total_row_diagram.appendChild(risorsa_cell);

            // Creo i td per la riga del calcolo operatori
            for (let i = 1; i <= this.blocks.length; i++) {
                const startcell = document.createElement('td');
                startcell.id = i;
                startcell.setAttribute("tipo", "td-calcolo-operatori");
                total_row_diagram.appendChild(startcell);
            }

            body.appendChild(total_row_diagram);

        }
        // Creo le righe con nome id quello della macchina
        for (let t = 0; t < prima_col_length; t++) {
            const total_row_diagram = document.createElement('tr');
            total_row_diagram.setAttribute('riga', 0);
            total_row_diagram.setAttribute('elemento', "attivita_row");
            total_row_diagram.id = nome_prima_col + prima_col[t][nome_key] + "-" + 0;
            const risorsa_cell = document.createElement('td');

            if (nome_prima_col == "attivita") {
                risorsa_cell.innerHTML = prima_col[t].des_attivita.macchina;
            }

            if (nome_prima_col == "operatori") {
                risorsa_cell.innerHTML = `<span class="nome_oper">${prima_col[t].nome} </span>${prima_col[t].cognome}`
            }

            risorsa_cell.setAttribute('data-itemtype', 1);
            risorsa_cell.setAttribute('class', "col_" + nome_prima_col);
            total_row_diagram.appendChild(risorsa_cell);

            // Creo i td della riga

            for (let i = 1; i <= this.blocks.length; i++) {
                const startcell = document.createElement('td');
                startcell.id = i;
                startcell.setAttribute(nome_prima_col, prima_col[t][nome_key]);
                startcell.addEventListener('dragover', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('dragleave', function (e) {
                    e.preventDefault()
                }, false);
                startcell.addEventListener('drop', ondrop);

                total_row_diagram.appendChild(startcell);
            }

            body.appendChild(total_row_diagram);

            // Stabilisco se ci sono sovrapposizioni tra i task 

            let task_macchina = new Array();
            if (nome_prima_col == "attivita") {

                // Salvo tutte le task di una macchina

                await new Promise((resolve) => {
                    alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
                        SELECT * FROM commessa_db.task WHERE ${nome_key} = ${prima_col[t][nome_key]} ORDER BY data_inizio`, [], function (res) {
                        for (let i = 0; i < res[1].length; i++) {
                            task_macchina[i] = res[1][i];
                        }
                        resolve();
                    });
                });
            } else {

                for (let ta = 0; ta < tasks.length; ta++) {
                    for (let r = 0; r < tasks[ta].operatori.length; r++) {
                        if (tasks[ta].operatori[r] == prima_col[t][nome_key]) {
                            task_macchina.push(tasks[ta]);
                        }
                    }
                }
                //console.log(prima_col[t][nome_key]);
                //console.log(task_macchina); 
            }

            let sovrapposizioni = 0;
            let sovrapp_tot = 0;
            // console.log(task_macchina);
            for (let t1 = 0; t1 < task_macchina.length; t1++) {

                //console.log("Id t1: " + task_macchina[t1].id_task + " Riga t1: " + task_macchina[t1].riga);

                for (let t2 = t1 + 1; t2 < task_macchina.length; t2++) {
                    if (t1 != t2) {
                        //console.log("Sovrapposti?");
                        //console.log(this.ifSovrapposto(task_macchina, t1, t2));
                        if (this.ifSovrapposto(task_macchina, t1, t2, start_date)) {
                            sovrapposizioni = 0;
                            if (nome_prima_col != "attivita") {
                                sovrapposizioni = task_macchina[t2].riga;
                            }
                            if (task_macchina[t2].riga == task_macchina[t1].riga) {
                                task_macchina[t2].riga = task_macchina[t2].riga + 1;
                                await new Promise((resolve) => {
                                    sovrapposizioni = task_macchina[t2].riga;

                                    alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
                                            UPDATE commessa_db.task SET riga = ${task_macchina[t2].riga} WHERE id_task = ${task_macchina[t2].id_task}`, [], function () {
                                        for (let z = 0; z < tasks.length; z++) {
                                            if (tasks[z].id_task == task_macchina[t2].id_task) {
                                                tasks[z].riga = task_macchina[t2].riga;
                                            }
                                        }
                                        resolve();
                                    });
                                });
                            }

                            if (sovrapposizioni > sovrapp_tot) {
                                sovrapp_tot = sovrapposizioni;
                            }
                        }
                        //console.l og("Id t2: " + task_macchina[t2].id_task + " Riga t2: " + task_macchina[t2].riga);
                    }
                }
            }

            let righe_agg = sovrapp_tot;

            // Creo righe in più

            for (let l = 1; l <= righe_agg; l++) {
                const righe = document.createElement('tr');
                righe.id = nome_prima_col + prima_col[t][nome_key] + "-" + l;
                righe.setAttribute('riga', l);
                righe.setAttribute('elemento', "attivita_row");

                for (let i = 0; i <= this.blocks.length; i++) {
                    const startcell = document.createElement('td');
                    if (i == 0) {
                        startcell.setAttribute('class', "col_" + nome_prima_col);
                    }
                    startcell.setAttribute('attivita', prima_col[t][nome_key]);
                    startcell.id = i;
                    startcell.addEventListener('dragover', function (e) {
                        e.preventDefault()
                    }, false);
                    startcell.addEventListener('dragleave', function (e) {
                        e.preventDefault()
                    }, false);
                    startcell.addEventListener('drop', ondrop);

                    righe.appendChild(startcell);
                }

                body.appendChild(righe);
            }
        }
        let num_task = 0;

        // Devo creare il totale di operatori per turno, giorno, settimana in base a visualizzazione
        if (nome_prima_col == "operatori") {
            // Caso turni
            if (this.zoom == 2) {
                for (let i = 0; i < info.length; i++) {
                    let data_info = new Date(info[i].giorno);
                    let pos_info = Math.ceil(this.stepNumber(start_date, data_info));
                    if (this.stepNumber(start_date, data_info) % 1 == 0) {
                        pos_info = pos_info * 1 + 1;
                    }

                    if (this.stepNumber(start_date, data_info) < 0) {
                        pos_info = 1;
                    }

                    switch (info[i].turno) {
                        case "T2":
                            pos_info = pos_info + 1;

                            break;
                        case "T3":
                            pos_info = pos_info + 2;
                            break;
                    }
                    const target = document.getElementById("calcolo-operatori").getElementsByTagName('td')[pos_info];

                    target.innerHTML = `
                    <span class="tot_operatori">${info[i].numero}</span>
                `;

                    target.setAttribute('data-itemtype', 0);
                    target.setAttribute('id_info', info[i].id_info);

                }
            } else if (this.zoom == 3) {
                let info_giorni = [];
                info.forEach((inf) => {
                    // Controllo se ho già aggiunto la data al nuovo array
                    let index = info_giorni.findIndex(e => e.giorno === inf.giorno);
                    // Trovato
                    if (index > -1) {
                        info_giorni[index].numero = info_giorni[index].numero + inf.numero;
                    } else {
                        let infor = {
                            giorno: inf.giorno,
                            numero: inf.numero,
                        }
                        info_giorni.push(infor);
                    }
                });

                console.log(info_giorni);
                for (let i = 0; i < info_giorni.length; i++) {
                    let data_info = new Date(info_giorni[i].giorno);

                    let pos_info = Math.ceil(this.stepNumber(start_date, data_info)) * 1 + 1;
                    if (this.stepNumber(start_date, data_info) % 1 == 0) {
                        pos_info = pos_info * 1 + 1;
                    }

                    if (this.stepNumber(start_date, data_info) < 0) {
                        pos_info = 1;
                    }
                    console.log("Pos info:", pos_info);
                    const target = document.getElementById("calcolo-operatori").getElementsByTagName('td')[pos_info];

                    target.innerHTML = `
                    <span class="tot_operatori">${info_giorni[i].numero}</span>
                `;

                    target.setAttribute('data-itemtype', 0);
                    target.setAttribute('id_info', info_giorni[i].id_info);

                }
            } else if (this.zoom == 4) {
                let info_giorni = [];
                let data_iniziale = new Date(start_date);
                data_iniziale.setHours("00");
                //console.log(data_iniziale);
                info.forEach((inf) => {
                    inf.operatori = inf.operatori.replace(/[']/g, '').split(",").map(Number);
                    //console.log(inf.operatori);
                    //console.log(inf.giorno);
                    // Controllo se ho già aggiunto la data al nuovo array
                    let index = info_giorni.findIndex(e => {
                        let data1 = new Date(e.giorno);
                        let data2 = new Date(inf.giorno);
                        if ((this.stepNumber(data_iniziale, data1) | 0) === (this.stepNumber(data_iniziale, data2) | 0)) {
                            return true;
                        } else return false;
                    });
                    console.log(index);

                    // Trovato
                    if (index > -1) {
                        let piu_op = 0;
                        inf.operatori.forEach((op) => {
                            if (!info_giorni[index].operatori.includes(op)) {
                                piu_op++;
                                info_giorni[index].operatori.push(op);
                            }
                        });

                        info_giorni[index].numero = info_giorni[index].numero + piu_op;
                    } else {
                        let infor = {
                            giorno: inf.giorno,
                            numero: inf.numero,
                            operatori: inf.operatori,
                        }
                        info_giorni.push(infor);
                    }
                });

                //console.log(info_giorni);
                for (let i = 0; i < info_giorni.length; i++) {
                    let data_info = new Date(info_giorni[i].giorno);
                    //console.log(this.stepNumber(data_iniziale, data_info));
                    let pos_info = Math.ceil(this.stepNumber(data_iniziale, data_info));
                    if (this.stepNumber(data_iniziale, data_info) % 1 == 0) {
                        pos_info = pos_info * 1 + 1;
                    }

                    if (this.stepNumber(data_iniziale, data_info) < 0) {
                        pos_info = 1;
                    }
                    //console.log(data_info);
                    //console.log("Pos info:", pos_info);
                    const target = document.getElementById("calcolo-operatori").getElementsByTagName('td')[pos_info];

                    target.innerHTML = `
                    <span class="tot_operatori">${info_giorni[i].numero}</span>
                `;

                    target.setAttribute('data-itemtype', 0);
                    target.setAttribute('id_info', info_giorni[i].id_info);

                }
            }
        }
        //Stabilisce l'unità di misura della differenza di tempo nel context menu
        for (let i = 0; i < tasks.length; i++) {
            num_task++;
            let misura = "";
            let conversione = "";
            switch (this.zoom) {
                case HALF_HOUR:
                    misura = "mezz'ore";
                    conversione = 1 / 2;
                    break;
                case HOUR:
                    misura = "ore";
                    conversione = 1;
                    break;
                case DAY:
                    misura = "giorni";
                    conversione = 24 * 1;
                    break;
                case WEEK:
                    misura = "settimane";
                    conversione = 168 * 1;
                    break;
                case SHIFT:
                    misura = "turni";
                    conversione = 8 * 1;
                    break;
                case MONTH:
                    misura = "mesi";
                    conversione = 720 * 1;
                    break;
                case YEAR:
                    misura = "anni";
                    conversione = 8640 * 1;
                    break;
            }

            //Creazione e inserimento task

            let data_task = new Date(tasks[i].data_inizio);
            let data_fine = new Date(tasks[i].data_fine);

            let pos_ini = Math.ceil(this.stepNumber(start_date, data_task));
            //console.log("Data task: ", data_task);
            //console.log("Pos_iniz: " + this.stepNumber(start_date, data_task));

            if (this.stepNumber(start_date, data_task) % 1 == 0) {
                pos_ini = pos_ini * 1 + 1;
            }

            if (this.stepNumber(start_date, data_task) < 0) {
                pos_ini = 1;
            }

            if (this.zoom == 2) {
                //pos_ini = Math.round(this.stepNumber(start_date, data_task));
                pos_ini = pos_ini - 1;
            }

            let completamento = tasks[i].percentuale * 100;
            let tempo_context = "";
            let tempo_ore = "";
            if (misura == "turni") {
                tempo_context = Math.ceil(this.stepNumber(data_task, data_fine)) * 1;
                tempo_ore = this.stepNumber(data_task, data_fine);
            } else if (misura == "ore") {
                tempo_context = Math.round(this.stepNumber(data_task, data_fine)) * 1 + 1;
                tempo_ore = Math.round(this.stepNumber(data_task, data_fine)) * 1 + 1;
            } else {
                tempo_context = Math.ceil(this.stepNumber(data_task, data_fine));
                tempo_ore = this.stepNumber(data_task, data_fine);
            }

            if (nome_prima_col == "attivita") {

                let operatori_task = new Array();
                let competenze = new Array();

                for (let l = 0; l < tasks[i].operatori.length; l++) {
                    operatori_task[l] = tasks[i].operatori[l];
                }

                if (tasks[i].competenze_richieste != null) {
                    for (let l = 0; l < tasks[i].competenze_richieste.length; l++) {
                        competenze[l] = tasks[i].competenze_richieste[l].des_competenza;
                    }
                }
                for (let t = 0; t < oper_list.length; t++) {
                    for (let k = 0; k < operatori_task.length; k++) {
                        if (operatori_task[k] == oper_list[t].id_personale) {
                            operatori_task[k] = oper_list[t].cognome;
                        }
                    }
                }

                // Formattazione degli array per il context menu
                let text_op = operatori_task.toString();
                let oper_format = text_op.replace(/,/g, ', ');

                //let text_comp = competenze_task.toString();
                //let comp_format = text_comp.replace(/,/g, ', ');
                //console.log(start_date, data_task);
                //console.log(pos_ini);
                const target = document.getElementById(nome_prima_col + tasks[i][nome_key] + "-" + tasks[i].riga).getElementsByTagName('td')[pos_ini];

                // cod_task = codice articolo prodotto
                //des_task = nome fase
                target.innerHTML = `
            
            <figure data-itemtype="4" id_task="${tasks[i].id_task}"
            >
            <div>
            <span id="articolo" class="info_articolo">
                <button type="button" style="padding: 1px;" bottone="minus_half" id_task="${tasks[i].id_task}" data_inizio="${tasks[i].data_inizio}" data_fine="${tasks[i].data_fine}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-minus-circle-outline theme--light primary--text text--darken-2"></i></button>                
                <button type="button" style="padding: 1px;" bottone="plus_half" id_task="${tasks[i].id_task}" data_inizio="${tasks[i].data_inizio}" data_fine="${tasks[i].data_fine}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-plus-circle-outline theme--light primary--text text--darken-2"></i></button>
                <b>
                    <span class="cod_articolo">${tasks[i].cod_task}</span>
                    <span class="des_articolo">-${tasks[i].bag.descrizioneArticolo}</span>
                </b>
            </span>
            <span><i aria-hidden="true" class="v-icon notranslate mdi mdi-hand-back-right theme--light black--text text--lighten-2"></i><b><span class="cod_commessa">${tasks[i].bag.cod_Commessa}</span><span class="fase">-${tasks[i].bag.descrizioneFase}</span></b></span>
            <span id="completamento"></span>
            </div>                
            </figure>
            <nav class="context-menu-${i}">
            <h3><span>${tasks[i].bag.cod_articolo}</span><span>-${tasks[i].bag.cod_Commessa}</span>-${tasks[i].bag.descrizioneFase}</h3>
            <ul class="context-menu__items">
                <li class="context-menu__item">
                <b>Competenze</b>: ${competenze.join(', ')}
                </li>
                <li class="context-menu__item">
                <b>Operatori assegnati</b>: ${oper_format}
                </li>
                <li class="context-menu__item">
                <b>Tempo</b>: ${tempo_context} ${misura} / ${Math.ceil(tempo_ore * conversione)} ore
                </li>
                <li class="context-menu__item">
                <b>Quantità commessa</b>: ${tasks[i].produzione_job[0].quantita_commessa} 
                </li>
                <li class="context-menu__item">
                <b>Consumo materiale</b>: ${tasks[i].produzione_job[0].consumo_materiale_task} 
                </li>
                <li class="context-menu__item">
                <b>Consumo materiale totale</b>: ${tasks[i].produzione_job[0].consumo_materiale_totale} 
                </li>
                <li class="context-menu__item">
                <b>Completamento</b>: ${completamento} %
                </li>
                <li class="context-menu__item">
                <button type="button" style="border: 1px solid #0033CC; border-radius: 3px; padding: 2px;" bottone="Cambio_colore" commessa="${tasks[i].id_riferimento}"colore_sfondo="${tasks[i].colore_sfondo}" colore_testo="${tasks[i].colore_testo}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-palette theme--light primary--text text--darken-2"></i></button>
                <button type="button" style="border: 1px solid #0033CC; border-radius: 3px; padding: 2px;" bottone="cambia_date" id_task="${tasks[i].id_task}" data_inizio="${tasks[i].data_inizio}" data_fine="${tasks[i].data_fine}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-calendar-clock-outline theme--light primary--text text--darken-2"></i></button>
                </li>
            </ul>
            </nav>
            `;


                // bottone cambio numero operatori
                // <button type="button" style="border: 1px solid #0033CC; border-radius: 3px; padding: 2px;" bottone="num_operatori" commessa="${tasks[i].id_riferimento}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-account theme--light primary--text text--darken-2"></i></button>

                //console.log(tasks[i].bag.descrizioneArticolo);
                //Pulsante del context menu per cambiare operatori (potrebbe non servire più)
                //<button type="button" style="border: 1px solid black; border-radius: 3px; padding: 2px;" bottone="Nuovo_op" commessa="${tasks[i].id_riferimento}" operatori_attuali="${tasks[i].operatori}">Nuovo operatore</button>
                if (this.zoom == 1) {
                    target.style.setProperty('--duration', (this.stepNumber(data_task, data_fine) * 1 + 1 - 2.7 * this.zoom / 100 * this.stepNumber(data_task, data_fine)));
                } else { target.style.setProperty('--duration', (this.stepNumber(data_task, data_fine) * 1 - 1.5 * this.zoom / 100 * this.stepNumber(data_task, data_fine))); }

                target.style.setProperty('--colore_sfondo', tasks[i].colore_sfondo);
                if (this.zoom == 2 || this.zoom == 3 || this.zoom == 4) {
                    target.style.setProperty('--overflow', "visible");
                } else {
                    target.style.setProperty('--overflow', "hidden");
                }

                target.style.setProperty('--colore_testo', tasks[i].colore_testo);
                if (this.zoom == 1) {
                    //console.log(this.stepNumber(data_task, data_fine) * 1 + 1);
                    target.setAttribute('durata', this.stepNumber(data_task, data_fine)) * 1 + 1;
                } else { target.setAttribute('durata', this.stepNumber(data_task, data_fine)); }

                if (this.zoom == 1) {
                    target.setAttribute('lunghezza', this.stepNumber(data_task, data_fine)) * 1 + 1;
                } else { target.setAttribute('lunghezza', this.stepNumber(data_task, data_fine)); }


                target.setAttribute(nome_prima_col, tasks[i][nome_key]);

                target.style.setProperty('--completamento', completamento);

                target.setAttribute('data-itemtype', 0);
                target.setAttribute('id_task', tasks[i].id_task);
                target.setAttribute('draggable', 'true');
                let activeClassName = "context-menu--active";
                let menuState = 0;
                let menu = document.querySelector(".context-menu-" + i);
                menu.style = "display: none; position: absolute; background: white; border: 1px solid black; z-index:3";

                //Aggiungo l'evento click sinistro per aprire il menu delle task
                target.addEventListener('contextmenu', function (e) {
                    e.preventDefault();
                    if (menuState == 0) {
                        menuState = 1;
                        menu.classList.add(activeClassName);

                    }
                    else if (menuState == 1) {
                        menuState = 0;
                        menu.classList.remove(activeClassName);
                    }
                }, false);

                target.addEventListener('dragstart', function (e) {
                    let target = e.target;
                    dragged = target;
                    e.dropEffect = 'move';
                });

            }

            else {

                for (let j = 0; j < tasks[i].operatori.length; j++) {

                    //console.log("Id riga: ", nome_prima_col + tasks[i].operatori[j] + tasks[i].riga);
                    const target = document.getElementById(nome_prima_col + tasks[i].operatori[j] + "-" + tasks[i].riga).getElementsByTagName('td')[pos_ini];

                    let operatori_task = new Array();
                    let operatori_disp = new Array();
                    let competenze = new Array();


                    for (let l = 0; l < tasks[i].operatori.length; l++) {
                        operatori_task[l] = tasks[i].operatori[l];
                    }

                    if (tasks[i].operatori_con_competenze != null && tasks[i].operatori_con_competenze.length != 0) {
                        for (let l = 0; l < tasks[i].operatori_con_competenze.length; l++) {
                            operatori_disp[l] = tasks[i].operatori_con_competenze[l];
                        }
                    }

                    if (tasks[i].competenze_richieste != null && tasks[i].competenze_richieste.length != 0) {
                        for (let l = 0; l < tasks[i].competenze_richieste.length; l++) {
                            competenze[l] = tasks[i].competenze_richieste[l].des_competenza;
                        }
                    }

                    for (let t = 0; t < prima_col.length; t++) {
                        for (let k = 0; k < operatori_task.length; k++) {
                            if (operatori_task[k] == prima_col[t].id_personale) {
                                operatori_task[k] = prima_col[t].cognome;
                            }
                        }

                        for (let di = 0; di < operatori_disp.length; di++) {
                            if (operatori_disp[di] == prima_col[t].id_personale) {
                                operatori_disp[di] = prima_col[t].cognome;
                            }

                        }
                    }

                    // Formattazione degli array per il context menu
                    let text_op = operatori_task.toString();
                    let oper_format = text_op.replace(/,/g, ', ');

                    let text_op_disp = operatori_disp.toString();
                    let oper_format_disp = text_op_disp.replace(/,/g, ', ');

                    target.innerHTML = `
            
            <figure data-itemtype="4" id_task="${tasks[i].id_task}"
            >
            <div>
            <span id="articolo" class="info_articolo">    
                <button type="button" style="padding: 1px;" bottone="minus_half" id_task="${tasks[i].id_task}" data_inizio="${tasks[i].data_inizio}" data_fine="${tasks[i].data_fine}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-minus-circle-outline theme--light primary--text text--darken-2"></i></button>                
                <button type="button" style="padding: 1px;" bottone="plus_half" id_task="${tasks[i].id_task}" data_inizio="${tasks[i].data_inizio}" data_fine="${tasks[i].data_fine}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-plus-circle-outline theme--light primary--text text--darken-2"></i></button>
                <b>
                    <span class="cod_articolo">${tasks[i].cod_task}</span>
                    <span class="des_articolo">-${tasks[i].bag.descrizioneArticolo}</span
                ></b>
            </span>
            <span><i aria-hidden="true" class="v-icon notranslate mdi mdi-hand-back-right theme--light black--text text--lighten-2"></i><b><span class="cod_commessa">${tasks[i].bag.cod_Commessa}</span><span class="fase">-${tasks[i].bag.descrizioneFase}</span></b></span>
            <span id="completamento"></span>
            </div>                
            </figure>
            <nav class="context-menu-${i}">
            <h3><span>${tasks[i].bag.cod_articolo}</span><span>-${tasks[i].bag.cod_Commessa}</span>-${tasks[i].bag.descrizioneFase}</h3>
            <ul class="context-menu__items">
                <li class="context-menu__item">
                <b>Competenze</b>: ${competenze.join(', ')}
                </li>
                <li class="context-menu__item lista_operatori">
                <b>Operatori assegnati</b>: ${oper_format}
                </li>
                <li class="context-menu__item">
                <b>Operatori disponibili</b>: ${oper_format_disp}
                </li>
                <li class="context-menu__item">
                <b>Tempo</b>: ${tempo_context} ${misura} / ${Math.ceil(tempo_ore * conversione)}  ore
                </li>
                <li class="context-menu__item">
                <b>Quantità commessa</b>: ${tasks[i].produzione_job[0].quantita_commessa} 
                </li>
                <li class="context-menu__item">
                <b>Consumo materiale</b>: ${tasks[i].produzione_job[0].consumo_materiale_task} 
                </li>
                <li class="context-menu__item">
                <b>Consumo materiale totale</b>: ${tasks[i].produzione_job[0].consumo_materiale_totale} 
                </li>
                <li class="context-menu__item">
                <b>Completamento</b>: ${completamento} %
                </li>
                <li class="context-menu__item">
                <button type="button" style="border: 1px solid #0033CC; border-radius: 3px; padding: 2px;" bottone="Cambio_colore" commessa="${tasks[i].id_riferimento}" colore_sfondo="${tasks[i].colore_sfondo}" colore_testo="${tasks[i].colore_testo}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-palette theme--light primary--text text--darken-2"></i></button>
                <button type="button" style="border: 1px solid #0033CC; border-radius: 3px; padding: 2px;" bottone="cambia_date" id_task="${tasks[i].id_task}" data_inizio="${tasks[i].data_inizio}" data_fine="${tasks[i].data_fine}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-calendar-clock-outline theme--light primary--text text--darken-2"></i></button>
                </li>
                
            </ul>
            </nav>
            `;
                    // bottone cambio numero operatori
                    // <button type="button" style="border: 1px solid #0033CC; border-radius: 3px; padding: 2px;" bottone="num_operatori" commessa="${tasks[i].id_riferimento}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-account theme--light primary--text text--darken-2"></i></button>

                    if (this.zoom != 1) {
                        target.style.setProperty('--duration', (this.stepNumber(data_task, data_fine) * 1 - 1.5 * this.zoom / 100 * this.stepNumber(data_task, data_fine)));
                    } else { target.style.setProperty('--duration', (this.stepNumber(data_task, data_fine) * 1 + 1 - 2.7 * this.zoom / 100 * this.stepNumber(data_task, data_fine))); }
                    target.style.setProperty('--colore_sfondo', tasks[i].colore_sfondo);
                    target.style.setProperty('--colore_testo', tasks[i].colore_testo);
                    if (this.zoom == 1) {
                        target.setAttribute('durata', this.stepNumber(data_task, data_fine)) * 1 + 1;
                    } else { target.setAttribute('durata', this.stepNumber(data_task, data_fine)); }

                    if (this.zoom == 2 || this.zoom == 3 || this.zoom == 4) {
                        target.style.setProperty('--overflow', "visible");
                    } else {
                        target.style.setProperty('--overflow', "hidden");
                    }

                    if (this.zoom == 1) {
                        target.setAttribute('lunghezza', this.stepNumber(data_task, data_fine)) * 1 + 1;
                    } else { target.setAttribute('lunghezza', this.stepNumber(data_task, data_fine)); }

                    target.setAttribute('lunghezza', this.stepNumber(data_task, data_fine));
                    target.setAttribute(nome_prima_col, tasks[i].operatori[j]);

                    target.style.setProperty('--completamento', completamento);
                    target.setAttribute('data-itemtype', 0);
                    target.setAttribute('id_task', tasks[i].id_task);
                    target.setAttribute('num_operatori', tasks[i].operatori.length);
                    target.setAttribute('draggable', 'true');
                    let activeClassName = "context-menu--active";
                    let menuState = 0;
                    //let menu = document.querySelector(".context-menu-" + i);
                    //let menu = document.querySelectorAll(".context-menu-" + i);
                    let menu = target.getElementsByTagName("nav")[0];
                    menu.style = "display: none; position: absolute; background: white; border: 1px solid black; z-index:3";

                    //Aggiungo l'evento click sinistro per aprire il menu delle task
                    target.addEventListener('contextmenu', function (e) {
                        e.preventDefault();
                        if (menuState == 0) {
                            menuState = 1;
                            menu.classList.add(activeClassName);
                            let nuovi_operatori = new Array();

                            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
                                SELECT * FROM commessa_db.task WHERE id_task = ${tasks[i].id_task}`, [], function (res) {
                                for (let i = 0; i < res[1][0].operatori.length; i++) {
                                    nuovi_operatori[i] = res[1][0].operatori[i];
                                }

                                for (let t = 0; t < prima_col.length; t++) {
                                    for (let k = 0; k < nuovi_operatori.length; k++) {
                                        if (nuovi_operatori[k] == prima_col[t].id_personale) {
                                            nuovi_operatori[k] = prima_col[t].cognome;
                                        }
                                    }
                                }
                                target.getElementsByClassName("lista_operatori")[0].innerHTML = '<b>Operatori assegnati</b>: ' + nuovi_operatori.join(', ');
                            });


                        }
                        else if (menuState == 1) {
                            menuState = 0;
                            menu.classList.remove(activeClassName);
                        }
                    }, false);

                    target.addEventListener('dragstart', function (e) {
                        let target = e.target;
                        dragged = target;
                        e.dropEffect = 'move';
                    });

                }
            }
        }

        console.log("Numero task: " + num_task);
        for (let i = 0; i < 10; i++) {
            const total_row_diagram = document.createElement('tr');
            const risorsa_cell = document.createElement('td');
            risorsa_cell.innerHTML = "ciao";
            risorsa_cell.style.height = "100%";
            risorsa_cell.style.border = "none";
            risorsa_cell.setAttribute('extra', 0);
            total_row_diagram.appendChild(risorsa_cell);
            body.appendChild(total_row_diagram);
        }

        await new Promise((resolve) => {
            alasql(`ATTACH INDEXEDDB DATABASE commessa_db; \
        UPDATE commessa_db.task SET riga = 0`, [], function () {
                resolve();
                // console.log("Azzerato riga");
            });
        });

    }

    getFormatter(date) {
        switch (this.zoom) {
            case HALF_HOUR: {
                return function () {
                    const value = {
                        upper: `${week_names[date.getDay()]} ${date.getDate()} ${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${date.getHours()}:${date.getMinutes().toString().padStart(2, "0")}`

                    };
                    date.setMinutes(date.getMinutes() + 30);
                    return value;
                }
            }
            case HOUR: {
                return function () {
                    const value = {
                        upper: `${week_names[date.getDay()]} ${date.getDate()} ${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${date.getHours()}:00`
                    };
                    date.setHours(date.getHours() + 1);
                    return value;
                }
            }
            case SHIFT: {
                return function () {
                    const temp_date = new Date(date.getTime());
                    temp_date.setHours(date.getHours() + 8);
                    const value = {
                        upper: `${week_names[date.getDay()]} ${date.getDate()} ${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${Math.ceil(date.getHours() / 8)}`
                    };
                    date.setHours(date.getHours() + 8);
                    return value;
                }
            }
            case DAY: {
                return function () {
                    const value = {
                        upper: `${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${week_names[date.getDay()]} ${date.getDate()}`
                    };
                    date.setDate(date.getDate() + 1);
                    return value;
                }
            }
            case WEEK: {
                return function () {
                    const temp_date = new Date(date.getTime());
                    temp_date.setDate(date.getDate() + 6);
                    const value = {
                        upper: `${month_names[date.getMonth()]} ${date.getFullYear()}`,
                        lower: `${Math.ceil(date.getDate() / 7)}`
                    };
                    date.setDate(date.getDate() + 7);
                    return value;
                }
            }
            case MONTH: {
                return function () {
                    const value = {
                        upper: date.getFullYear(),
                        lower: `${month_names[date.getMonth()]}`
                    };
                    date.setMonth(date.getMonth() + 1);
                    return value;
                }
            }
            case YEAR: {
                return function () {
                    const value = {
                        upper: Math.floor(date.getFullYear() / 10) * 10,
                        lower: date.getFullYear()
                    };
                    date.setFullYear(date.getFullYear() + 1);
                    return value;
                }
            }

        }
    }

    setStep() {
        switch (this.zoom) {
            case HALF_HOUR:
                Date.prototype.step = function (diff) { this.setMinutes(this.getMinutes() + (diff * 30)); }
                break;
            case HOUR:
                Date.prototype.step = function (diff) { this.setHours(this.getHours() + diff); }
                break;
            case SHIFT:
                Date.prototype.step = function (diff) { this.setHours(this.getHours() + (diff * 8)); }
                break;
            case DAY:
                Date.prototype.step = function (diff) { this.setDate(this.getDate() + diff); }
                break;
            case WEEK:
                Date.prototype.step = function (diff) { this.setDate(this.getDate() + (diff * 7)); }
                break;
            case MONTH:
                Date.prototype.step = function (diff) { this.setMonth(this.getMonth() + diff); }
                break;
            case YEAR:
                Date.prototype.step = function (diff) { this.setFullYear(this.getFullYear() + diff); }
                break;
        }
    }

    unsetStep() { delete Date.prototype.step; }

    setZoom(zoomlevel) {
        this.zoom = zoomlevel;
        zoom1 = zoomlevel;
        this.setStep();
    }
    // Funzione che trasforma la differenza tra due date in differenza oraria e poi calcola gli step tra le date in base al passo
    stepNumber(data_inizio, data_fine) {
        let passi = 0;
        var diff = (data_fine.valueOf() - data_inizio.valueOf()) / (1000 * 3600); //Ore di differenza

        switch (this.zoom) {
            case 25: // Quarto d'ora
                passi = diff * 4;
                break;
            case HALF_HOUR: // Mezz'ora
                passi = diff * 2;
                break;
            case HOUR: // Ora
                passi = diff - 1;
                break;
            case DAY:
                passi = diff / 24;
                break;
            case WEEK:
                passi = diff / 168;
                break;
            case SHIFT:
                passi = diff / 8;
                break;
            case MONTH:
                passi = diff / 720;
                break;
            case YEAR:
                passi = diff / 8640;
                break;
        }
        return passi;
    }

    ifSovrapposto(task_macchina, t1, t2, start_date) {

        let sovrapposti = false;

        //Calcolo settimana dell'anno
        let currentdate1 = new Date(Date.parse(task_macchina[t1].data_inizio));
        /* var oneJan1 = new Date(currentdate1.getFullYear(), 0, 1);
        var numberOfDays1 = Math.floor((currentdate1 - oneJan1) / (24 * 60 * 60 * 1000));

        let currentdate1fin = new Date(Date.parse(task_macchina[t1].data_fine));
        var oneJan1fin = new Date(currentdate1fin.getFullYear(), 0, 1);
        var numberOfDays1fin = Math.floor((currentdate1fin - oneJan1fin) / (24 * 60 * 60 * 1000));
        //console.log("Numero giorni iniziale" + numberOfDays1); */

        let currentdate2 = new Date(Date.parse(task_macchina[t2].data_inizio));
       /*  var oneJan2 = new Date(currentdate2.getFullYear(), 0, 1);
        var numberOfDays2 = Math.floor((currentdate2 - oneJan2) / (24 * 60 * 60 * 1000));

        let currentdate2fin = new Date(Date.parse(task_macchina[t2].data_fine));
        var oneJan2fin = new Date(currentdate2fin.getFullYear(), 0, 1);
        var numberOfDays2fin = Math.floor((currentdate2fin - oneJan2fin) / (24 * 60 * 60 * 1000));

        var weekNum1_in = Math.ceil((currentdate1.getDay() + 1 + numberOfDays1) / 7);
        var weekNum1_fin = Math.ceil((currentdate1fin.getDay() + 1 + numberOfDays1fin) / 7);
        var weekNum2_in = Math.ceil((currentdate2.getDay() + 1 + numberOfDays2) / 7);
        var weekNum2_fin = Math.ceil((currentdate2fin.getDay() + 1 + numberOfDays2fin) / 7); */
        //console.log("Numero settimana iniziale" + weekNum1_in);

        switch (this.zoom) {
            case 25: // Quarto d'ora

                break;
            case HALF_HOUR: // Mezz'ora

                break;
            case HOUR: // Ora
                if (task_macchina[t1].data_inizio <= task_macchina[t2].data_inizio && task_macchina[t1].data_fine >= task_macchina[t2].data_inizio ||
                    task_macchina[t1].data_inizio <= task_macchina[t2].data_fine && task_macchina[t1].data_fine >= task_macchina[t2].data_fine) {
                    sovrapposti = true;
                }
                break;
            case DAY:
                if (task_macchina[t1].data_inizio <= task_macchina[t2].data_inizio && task_macchina[t1].data_fine >= task_macchina[t2].data_inizio ||
                    task_macchina[t1].data_inizio <= task_macchina[t2].data_fine && task_macchina[t1].data_fine >= task_macchina[t2].data_fine) {
                    sovrapposti = true;
                }
                break;
            case WEEK:
                /* if ((weekNum1_in <= weekNum2_in && weekNum1_fin >= weekNum2_fin) || (weekNum1_in >= weekNum2_fin && weekNum1_fin <= weekNum2_in)) {
                    sovrapposti = true;
                } */
                if ((this.stepNumber(start_date, currentdate1) | 0) === (this.stepNumber(start_date, currentdate2) | 0)) {
                    sovrapposti = true;
                }
                break;
            case SHIFT:
                if ((this.stepNumber(start_date, currentdate1) | 0) === (this.stepNumber(start_date, currentdate2) | 0)) {
                    sovrapposti = true;
                }
                break;
            case MONTH:
                break;
            case YEAR:

                break;
        }
        return sovrapposti;
    }


}
export default Calendar;